<template>
    <main>
        <div class="content">
            <div class="tip">
                <router-link :to="'/tech/advantage/laboratory'" :class="{ active: typeId == 'laboratory' }">{{ lang("nav_tech_laboratory") }}</router-link>
                <router-link v-for="item in typeKey" :to="'/tech/advantage/' + item.value" :class="{ active: typeId == item.value }">{{ item.label }}</router-link>
            </div>

            <div class="context">
                <div class="item" v-for="item in techList">
                    <div class="techImg">
                        <div v-if="item.technologyPicture && !id" @click="showDetail(item)">
                            <v-image :src="item.technologyPicture" width="340px" height="320px" class="image"></v-image>
                        </div>

                        <v-image :src="item.technologyPicture" width="340px" height="320px" v-else-if="item.technologyPicture && id" class="image"></v-image>
                        <!-- <img class="image" :src="item.technologyPicture" alt="" v-if="item.technologyPicture && !id" @click="showDetail(item)">
                        <img class="image" :src="item.technologyPicture" alt="" v-else-if="item.technologyPicture && id"> -->
                        <video :src="item.technologyVideo" v-else>
                            your browser does not support the video tag
                        </video>
                        <div v-if="item.technologyVideo" @click="play(item)">
                            <div class="mask"></div>
                            <img class="playBtn" src="../assets/images/play.png" alt="">
                        </div>
                    </div>
                    <div class="techName">{{ item.technologyName }}</div>
                </div>
            </div>

            <pager :xpages="pages" :xcurrent-page="pageNum" @pager="pageNum = $event"></pager>
        </div>

        <video-alert :videoUrl="videoUrl" ref="video"></video-alert>

        <transition name="fade">
            <div class="loginBox" v-if="advanDetail">
                <div class="box">
                    <div class="loginBg"></div>
                    <div class="login">
                        <div class="context">
                            <img :src="detail.technologyPicture" alt="">
                            <div>
                                <div>{{ detail.technologyName }}</div>
                                <div class="explain" v-html="detail.deviceExplain.replace(/\n/g, '<br/>')"></div>
                            </div>
                        </div>
                        <button class="close" @click.stop="advanDetail = false"></button>
                    </div>
                </div>

            </div>

        </transition>

    </main>
</template>
<style lang="less" scoped>
@red: #e60012;

.content {
    width: 1200px;
    margin: 30px auto;
    padding-bottom: 10px;
    min-height: 278px;

    .tip {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 40px;

        a {
            padding: 0 78px;
            height: 22px;
            line-height: 22px;
            cursor: pointer;

            &:not(:last-child) {
                border-right: 1px dashed #333333;
            }

            color: #353535;

            &.active,
            &:hover {
                color: @red;
                font-weight: bold;
            }

        }
    }

    .context {
        display: flex;
        flex-wrap: wrap;

        .item {
            margin: 0 10px 10px;

            .techImg {
                width: 340px;
                height: 320px;
                border: 1px solid #D2D2D2;
                border-radius: 4px;
                overflow: hidden;
                position: relative;
                cursor: pointer;

                video,
                div,
                img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    object-fit: cover;
                }

                .image {
                    transition: all .3s;

                    &:hover {
                        transform: scale(1.1);
                    }
                }

                .mask {
                    background-color: #ffffff;
                    opacity: 0.5;
                }

                .playBtn {
                    position: absolute;
                    top: 137px;
                    left: 147px;
                    width: 47px;
                    height: 47px;
                }
            }

            .techName {
                font-size: 14px;
                font-weight: 400;
                color: #353535;
                line-height: 54px;
            }
        }
    }
}

.loginBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 102;
    will-change: opacity;

    .box {
        position: relative;
        width: 720px;
        height: 344px;
    }

    .loginBg {
        position: absolute;
        top: 23px;
        width: 720px;
        height: 299px;
        z-index: 101;
        background-color: @red;
    }

    .login {
        position: absolute;
        left: 20px;
        width: 680px;
        height: 344px;
        background-color: #ffffff;
        padding: 26px 20px;
        border: none;
        overflow: hidden;
        z-index: 102;

        .context {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;

            img {
                height: 220px;
                margin-right: 30px;
                object-fit: cover;
            }

            div {
                font-size: 16px;
                font-weight: bold;
                color: #363636;
                text-align: left;

                &.explain {
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: 13px;
                    max-height: 200px;
                    overflow: scroll;
                }
            }
        }

        .close {
            border: none;
            width: 17px;
            height: 17px;
            position: absolute;
            right: 22px;
            top: 22px;
            background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
        }

    }
}

@media screen and (max-width: 1360px) {
    .content {
        margin-top: 0;
        width: auto;

        .tip {
            white-space: nowrap;
            overflow: auto;
            display: block;
            margin-bottom: 0;
            text-align: center;

            a {
                height: auto;
                display: inline-flex;
                padding: 15px 20px;

                &:not(:last-child) {
                    border-right: none;
                }
            }
        }
    }

    .context {
        width: 100% !important;
        margin-left: 0 !important;
        margin-top: 0 !important;
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        .item {
            margin: 0 0 20px !important;
            width: calc(50% - 10px) !important;

            .techImg {
                width: 100% !important;
                height: 0 !important;
                padding-top: 100% !important;
                position: relative !important;

                .v-image {
                    position: absolute;
                    width: 100% !important;
                    height: 100% !important;
                    top: 0;
                    left: 0;
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {
            typeKey: [],
            techList: [],
            typeId: '',
            playVideo: false,
            videoUrl: '',
            advanDetail: false,
            detail: {},
        }
    },
    computed: {
        id() {
            return this.$route.params.id
        }
    },
    mounted() {
        this.getTypeKey();
    },
    methods: {
        getTypeKey() {
            var that = this;
            that.$root.loading = true;
            that.techList = [];
            ajax.call(this, {
                url: "/admin/category/typeKey",
                data: {
                    // SERVER_SORT服务,PRODUCT_SORT产品,DEVICE_SORT设备,TECHNOLOGY_SORT工艺,POSITION_SORT职位,VIDEO_SORT视频,OTHER_SORT其他
                    typeKey: "TECHNOLOGY_SORT"
                },
                s(res) {
                    that.$root.loading = false;
                    that.typeKey = res.data;
                    if (that.id) {
                        that.getTechList(that.id)
                        return
                    }
                    that.getTechList("laboratory")
                }
            });
        },
        getTechList(index) {
            var that = this;
            that.typeId = index;
            that.getList();
        },
        getLaboratory() {
            var that = this;
            that.$root.loading = true;
            that.techList = [];
            ajax.call(this, {
                url: "/bloc/xjldevice/list/language",
                data: {
                    XJLLabName: that.$root.langMode == 0 ? "贤俊龙实验室" : "HYUN JUNLONG LABORATORY",
                    pageSize: 9
                },
                s(res) {
                    that.$root.loading = false;
                    that.techList = res.data
                }
            });
        },
        getList() {
            var that = this;
            if (that.typeId == 'laboratory') {
                that.getLaboratory();
                return;
            } else {
                that.$root.loading = true;
                that.techList = [];
                ajax.call(this, {
                    url: "/bloc/technology/list/language",
                    data: {
                        typeId: that.typeId,
                        pageSize: 9
                    },
                    s(res) {
                        that.$root.loading = false;
                        that.techList = res.data
                    }
                });
            }

        },
        showDetail(item) {
            this.advanDetail = true;
            this.detail = item;
        },
        play(item) {
            this.videoUrl = item.technologyVideo;
            this.$refs.video.played();
        }
    },
    watch: {
        "$root.language"() {
            if (this.id) {
                this.$router.push("/tech/advantage")
            } else {
                this.getTypeKey();
            }
        },
        id() {
            this.pageNum = 1;
            this.getTypeKey();
        }
    }

}
</script>